<template>
  <b-modal :active="value" has-modal-card @close="close()">
    <form action="">
      <div class="modal-card" style="width: 800px">
        <header class="modal-card-head">
          <p class="modal-card-title" style="color: whitesmoke">機器選択</p>
        </header>

        <section class="modal-card-body">
          <div id="AppSelectProduct" style="height: 350px">
            <!-- 消耗品選択 -->
            <div class="columns is-vcentered">
              <!-- 消耗品選択 -->
              <div class="column" style>
                <b-input
                  v-model="productCode"
                  name="productCode"
                  type="text"
                  placeholder="検索条件を入力してください"
                ></b-input>
              </div>
              <div>
                <b-button
                  class="button"
                  type="is-primary"
                  native-type="button"
                  @click="filteredProductList(productCode)"
                >
                  検索
                </b-button>
              </div>
              <div class="control column" style="min-height:350px;">
                <b-table
                  :data="filteredProduct"
                  :selected.sync="selectedProduct"
                  focusable
                  class="tableStyle"
                >
                  <template slot-scope="props">
                    <b-table-column field="officeCode">
                      {{ props.row.key }}
                    </b-table-column>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </section>

        <footer class="modal-card-foot">
          <div class="column is-full" style="text-align: center">
            <b-button
              v-on:click="close()"
              class="button"
              icon-left="keyboard-backspace"
              native-type="button"
            >
              戻る
            </b-button>
            <b-button
              v-on:click="select()"
              class="button"
              icon-left="content-save"
              native-type="button"
            >
              選択
            </b-button>
          </div>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  components: {},

  data() {
    let productMaster = [];
    this.getProductList(productMaster);

    return {
      productMaster,
      productCode: "",
      filteredProduct: [],
      selectedProduct: {},
    };
  },

  computed: {},

  methods: {
    close: function () {
      this.$emit("input", false);
      return;
    },

    filteredProductList: function (productCode) {
      if (productCode == "") {
        this.$dialog.alert({
          title: "　",
          message: "検索条件を指定してください。",
        });
      } else {
        this.filteredProduct = this.productMaster.filter((option) => {
          let retValue =
            option.key
              .toString()
              .toLowerCase()
              .indexOf(productCode.toLowerCase()) >= 0;
          return retValue;
        });
        if (this.filteredProduct.length == 0) {
          this.$dialog.alert({
            title: "　",
            message: "検索条件に当てはまる機器はありません。",
          });
        }
      }
    },

    select: function () {
      // 選択結果を画面に反映
      this.$emit("set-product", this.selectedProduct);
      this.close();
    },
  },

  mounted: function () {},

  filters: {},

  watch: {},
};
</script>

<style lang="scss" scoped>
  .tableStyle {
    border:solid 1px;
    border-color:lightgrey;
    width: 430px;
    height:300px;
    overflow-y:scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/selectProduct.vue